/**
 * Panel width constants used across the application.
 * These define the fixed widths for panels that overlay the surface.
 * Note: 1rem = 8px in this app (see dimensions.rem2px)
 */

import { dimensions } from '@annote/core/styles';

export const PANEL_WIDTHS_REM = {
  LIBRARY: 40, // Fixed width for library
  READER: 90, // Resizable (400-1000px)
  WRITER: 90, // Resizable (400-1000px)
  PROFILE: 48,
} as const;

/**
 * Panel width defaults in pixels.
 * Calculated from PANEL_WIDTHS_REM using dimensions.rem2px
 */
export const PANEL_WIDTHS_PX = {
  LIBRARY: PANEL_WIDTHS_REM.LIBRARY * dimensions.rem2px, // 40rem * 8px = 320px
  READER: PANEL_WIDTHS_REM.READER * dimensions.rem2px, // 90rem * 8px = 720px
  WRITER: PANEL_WIDTHS_REM.WRITER * dimensions.rem2px, // 90rem * 8px = 720px
  PROFILE: PANEL_WIDTHS_REM.PROFILE * dimensions.rem2px, // 48rem * 8px = 384px
} as const;

/**
 * Z-index layers for the application.
 */
export const Z_INDEX = {
  SURFACE: 1,
  PANELS: 100,
  ANNI_CHAT: 200, // Anni floats above panels but below nav
  NAV_BAR: 1000,
  DROPDOWN_MENU: 1001,
} as const;
